export const environment = {
    production: true,
    googleMapsApiKey: '',
    backend: 'http://localhost:4202',
    //backend: 'https://oiram.ntshub.es',
    //apiUrl: 'https://api.preoiram.ntshub.es/api' //preoiram
    apiUrl: 'https://api.oiram.ntshub.es/api'

  };